"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconsReact = require("../../../../icons-react");
var _excluded = ["name"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Avatar = /*#__PURE__*/function (_React$PureComponent) {
  function Avatar(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Avatar);
    _this = _callSuper(this, Avatar, [props]);
    _this.state = {
      hasError: false,
      url: props.url
    };
    _this.handleError = _this.handleError.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Avatar, _React$PureComponent);
  return (0, _createClass2["default"])(Avatar, [{
    key: "handleError",
    value: function handleError() {
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state = this.state,
        hasError = _this$state.hasError,
        url = _this$state.url;
      var hasImage = url && !hasError;
      return /*#__PURE__*/_react["default"].createElement(StyledAvatar, (0, _extends2["default"])({
        title: name
      }, props), hasImage ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: name,
        onError: this.handleError,
        src: url
      }) : /*#__PURE__*/_react["default"].createElement(_iconsReact.Avatar, null));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.url === state.url) {
        return null;
      }
      return {
        hasError: false,
        url: props.url
      };
    }
  }]);
}(_react["default"].PureComponent);
Avatar.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  url: _propTypes["default"].string,
  pulsing: _propTypes["default"].bool
};
Avatar.defaultProps = {
  className: '',
  name: '',
  url: '',
  pulsing: false
};
var StyledAvatar = _styledComponents["default"].div.withConfig({
  displayName: "Avatar__StyledAvatar",
  componentId: "sc-1ang2ot-0"
})(["border-radius:50%;height:40px;width:40px;position:relative;> *{display:block;height:100%;width:100%;background:#fff;border-radius:100%;}", ""], function (props) {
  return props.pulsing && "\n    &:before,\n    &:after {\n      top: 50%;\n      left: 50%;\n      content: '';\n      z-index: -1;\n      position: absolute;\n      border-radius: 100%;\n      animation: pulsing 1.5s infinite ease-in-out;\n      background-image: linear-gradient(to top, #00e04b, #00b0b6);\n    }\n\n    &:before {\n      width: 60px;\n      height: 60px;\n      opacity: 0.3;\n      margin-top: -30px;\n      margin-left: -30px;\n    }\n\n    &:after {\n      width: 48px;\n      height: 48px;\n      opacity: 0.8;\n      margin-top: -24px;\n      margin-left: -24px;\n    }\n\n    @keyframes pulsing {\n      from {transform: scale(.5);}\n    }\n  ";
});
var _default = exports["default"] = Avatar;